enum ContentTypes {
  APPLICATION_JSON = 'application/json',
  APPLICATION_PDF = 'application/pdf',
  MULTIPART_FORM_DATA = 'multipart/form-data',
}

export default ContentTypes;
